import { Card } from '@components/partials';
import { Pagination } from '@components/partials/Pagination';
import { Button, Checkbox, Column, DropdownData } from '@cloudclevr/components';
import { Person } from '@hooks/people/types';
import useTableStore from '@store/tableStore';
import { UseQueryResult } from '@tanstack/react-query';
import styles from './styles.module.css';

type MobileTableViewProps<T extends object> = {
  showCheckboxes: boolean;
  showBulkAction: boolean;
  bulkContent?: React.ReactElement;
  currentPage: number;
  totalPages: number;
  setPageNumber: (pageNumber: number) => void;
  query: UseQueryResult<any, any>;
  data: any[];
  headerKeyCard?: string;
  isCollapsable?: boolean;
  sliceColumns?: number;
  handleSelect: (selected: Person | null, all?: boolean) => void;
  handleBulkAction?: () => void;
  setDropDownTableRow?: (id: string) => void;
  setDropDownAction?: React.Dispatch<React.SetStateAction<string | undefined>>;
  dropDownData?: DropdownData[];
  showDropDownMobile?: boolean;
  columns: Column<T>[];
};

export const MobileTableView = <T extends object>({
  showCheckboxes,
  showBulkAction,
  bulkContent,
  currentPage,
  totalPages,
  setPageNumber,
  query,
  data,
  headerKeyCard,
  isCollapsable,
  sliceColumns,
  handleSelect,
  handleBulkAction,
  setDropDownTableRow,
  setDropDownAction,
  dropDownData,
  showDropDownMobile,
  columns,
}: MobileTableViewProps<T>) => {
  const {
    newlySelectedItems,
    selectedCountPerPage,
    totalItemsPerPage,
    allSelectedItems,
  } = useTableStore();
  const rawData = (query && query.data?.items) || [];

  return (
    <div className={styles.cardWrapper}>
      {data?.map((item: any, index: number) => (
        <Card
          testId={`mobile-table-card-${item?.id ?? index}`}
          headerKey={headerKeyCard}
          classNames="mb-4"
          columns={columns}
          item={{
            ...item,
          }}
          rawItem={rawData[index]}
          key={`card${index}`}
          isCollapsable={isCollapsable}
          sliceColumns={sliceColumns}
          allSelectedItems={allSelectedItems}
          handleSelect={handleSelect}
          showCheckboxes={showCheckboxes}
          setDropDownTableRow={setDropDownTableRow}
          setDropDownAction={setDropDownAction}
          dropDownData={dropDownData}
          showDropDownMobile={showDropDownMobile}
        />
      ))}
      {showCheckboxes && (
        <div className={styles.showCheckboxesWrapper}>
          <Checkbox
            testId="mobile-table-select-all-checkbox"
            defaultClassName={
              selectedCountPerPage[currentPage] &&
              selectedCountPerPage[currentPage] !==
                totalItemsPerPage[currentPage]
                ? 'ccCheckboxDefaultSelected'
                : ''
            }
            checked={
              selectedCountPerPage[currentPage] &&
              selectedCountPerPage[currentPage] ===
                totalItemsPerPage[currentPage]
                ? true
                : false
            }
            name={'all'}
            onChange={() => handleSelect(null, true)}
          />
          {newlySelectedItems.length > 0 && showBulkAction && (
            <Button
              testId='bulk-action-button'
              variant="outlineLight"
              onClick={handleBulkAction}
              size="small"
            >
              {bulkContent ? <>{bulkContent}</> : 'Bulk Action'}
            </Button>
          )}
        </div>
      )}

      {!query.isLoading && (
        <div className={styles.paginationWrapper}>
          <Pagination
            testId="mobile-table-pagination"
            currentPage={currentPage}
            totalPages={totalPages}
            setPageNumber={setPageNumber}
          />
        </div>
      )}
    </div>
  );
};
